module.exports = __webpack_public_path__ + "img/logo-posind-dark.cf985a83.png";